export const normalizePhone = (value: string | null) => {
  if (value === null || value.trim().length === 0) {
    return null;
  }

  const numbersInValue = value.replace(/[^\d]/g, '');
  if (numbersInValue.length <= 3) {
    return numbersInValue;
  }
  if (numbersInValue.length <= 7) {
    return `${numbersInValue.slice(0, 3)}-${numbersInValue.slice(3)}`;
  }
  return `${numbersInValue.slice(0, 3)}-${numbersInValue.slice(3, 6)}-${numbersInValue.slice(6)}`;
};

export const normalizeToTwoDigits = (value: string) => {
  if (value === '') {
    return null;
  }
  return Math.max(0, parseInt(value, 10)).toString().slice(0, 2);
};
